module.exports = __webpack_public_path__ + "static/card_homepage_square-55fd10735d0577f550f75ce7d064e2b8.jpg";